import { allPermissions, } from '../user/Permission.js';
export const commonModuleUrl = import.meta.url;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function versionRequestSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            version: {
                type: 'string',
            },
        },
        required: [
            'version',
        ],
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function versionResponseSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            status: {
                const: 'ok',
            },
            refresh: {
                type: 'boolean',
            },
            versions: {
                type: 'array',
                items: {
                    type: 'string',
                },
            },
        },
        required: [
            'status',
            'refresh',
            'versions',
        ],
    };
}
export async function version(baseUrl, props, signal) {
    const result = await fetch(`${baseUrl}/api/version/v1`, {
        signal,
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(props),
    });
    if (result.status === 200) {
        return await result.json();
    }
    if (result.status === 400) {
        return await result.json();
    }
    return {
        status: 'network error',
        httpStatus: result.status,
        message: await result.text(),
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function configRequestSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            // browser locale is sent in header
            // url locale is the current locale in the url, if any
            urlLocale: {
                type: 'string',
            },
            stateLocale: {
                type: 'string',
            },
            userLocale: {
                type: 'string',
            },
        },
    };
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function configResponseSchema() {
    return {
        type: 'object',
        additionalProperties: false,
        properties: {
            status: {
                const: 'ok',
            },
            user: {
                type: 'object',
                additionalProperties: false,
                properties: {
                    id: {
                        type: 'string',
                    },
                    permissions: {
                        type: 'array',
                        items: {
                            type: 'string',
                            enum: allPermissions,
                        },
                    },
                },
                required: [
                    'id',
                    'permissions',
                ],
            },
            locale: {
                type: 'string',
            },
        },
        required: [
            'status',
            'user',
            'locale',
        ],
    };
}
//# sourceMappingURL=CommonApi.js.map